import React from 'react';
import { useTheme } from '../../../ui';

/**
 * Web: renders generated HTML (letters) in a sandboxed iframe so its styles cannot leak into
 * the app and scripts cannot run.
 */
export function HtmlView({ html, height = 420 }: { html: string; height?: number }) {
  const { colors } = useTheme();
  return (
    <iframe
      title="Document preview"
      sandbox=""
      srcDoc={html}
      data-testid="html-view"
      style={{ width: '100%', height, border: `1px solid ${colors.border}`, borderRadius: 8, background: '#fff' }}
    />
  );
}
